<template>
  <div class="page-grid" :class="{ 'page-grid--empty': !isPersonExist }">

    <!-- 乘車注意事項彈窗 -->
    <div class="overlay" :class="{ active: showNoticeModal }">
      <div class="dialog dialog--notice">
        <div class="dialog-header">
          <span class="dialog-title">Boarding Notice</span>
          <!-- 點叉叉關閉彈窗 -->
          <button class="dialog-close" @click="closeNoticeModal"><i class="fa fa-times"></i></button>
        </div>
        <div class="dialog-body">
          <ul class="notice-modal-list">
            <li v-for="(note, idx) in busNoticeData" :key="idx">{{ note }}</li>
          </ul>
        </div>
        <div class="dialog-footer">
          <!-- 點 I understand 效果同叉叉 -->
          <button class="btn-primary" @click="closeNoticeModal">I understand</button>
        </div>
      </div>
    </div>

    <!-- impersonate -->
    <div
      v-if="!originalMailOrNot"
      class="impersonate-banner text-danger py-3 px-4 rounded bg-light text-center mb-5"
    >
      <i class="fa fa-user-secret pl-3"></i>
      {{ impersonateMail.split('@')[0] }}
    </div>

    <!-- Person not found：無資料時，整頁只顯示這個 -->
    <div v-if="!isPersonExist" class="person-not-found empty-status">
      <div class="icon"><i class="fa fa-user-times" aria-hidden="true"></i></div>
      <div class="title">No Data found</div>
    </div>

    <!-- 以下三大區塊，只有查得到人時才顯示 -->
    <template v-if="isPersonExist">
      <!-- 搜尋區塊 -->
      <div class="card search-card">
        <div class="card-body">
          <form class="tran-select-area" @submit.prevent="handleSubmit">
            <!-- 出發站下拉選單 -->
            <div class="tran-input-group">
              <label>Departure</label>
              <select v-model="form.stationStart" class="form-control">
                <option value="">All</option>
                <option v-for="(station, idx) in busStationData" :key="idx" :value="station.code">
                  {{ station.code }}
                </option>
              </select>
            </div>
            <!-- 抵達站下拉選單 -->
            <div class="tran-input-group">
              <label>Arrival</label>
              <select v-model="form.stationEnd" class="form-control">
                <option value="">All</option>
                <option v-for="(station, idx) in busStationData" :key="idx" :value="station.code">
                  {{ station.code }}
                </option>
              </select>
            </div>
            <!-- 出發日期 & 時間，預設為今天現在時刻 -->
            <div class="tran-input-group">
              <label>Depart at (GMT+8)</label>
              <div class="form-control date-input d-flex justify-content-between">
                <input
                  v-model="form.expectDepartureDate"
                  type="date"
                  :min="minDate"
                  :max="maxDate"
                  @change="validateDateTime"
                />
                <input
                  v-model="form.expectDepartureTime"
                  type="time"
                  :min="minTime"
                  @change="validateDateTime"
                />
              </div>
            </div>
            <!-- 送出搜尋 -->
            <button
              type="submit"
              class="tran-table-btn btn btn-block btn-primary"
              :disabled="isLoading"
            >
              Search
            </button>
          </form>
        </div>
      </div>

      <!-- ═══════════════════════════════════════════════════════════
          左側欄位：My Booking
          - 不論黑名單與否都顯示
          - 黑名單：可查看歷史預約，也可取消黑名單前的預約
          - 非黑名單：正常顯示預約清單與取消按鈕
          ═══════════════════════════════════════════════════════════ -->
      <div class="status-panel">
        <div class="status-panel-header">
          <i class="fa fa-ticket" style="color:#84754E" aria-hidden="true"></i>
          <span class="status-panel-title">My Booking</span>
        </div>

        <!-- 黑名單提示條 -->
        <div v-if="isBlacklisted" class="blacklist-banner">
          <div class="blacklist-icon">
            <i class="fa fa-ban" aria-hidden="true"></i>
          </div>
          <div class="blacklist-content">
            <span class="blacklist-title">Account Restricted</span>
            <span class="blacklist-text">You are currently restricted from making reservations.</span>
          </div>
        </div>

        <div class="status-panel-body">
          <!-- 有預約：顯示預約卡片清單 -->
          <div v-if="bookingList.length" id="state-booked">
            <div
              v-for="(booking, idx) in bookingList"
              :key="idx"
              class="booking-card"
            >
              <div class="booking-card-label">Reservation {{ idx + 1 }}</div>
              <!-- 路線顯示：出發站 → 抵達站 -->
              <div class="route-display">
                <div class="route-station">
                  <div class="time">{{ booking.departTime }}</div>
                  <div class="code">{{ booking.departStation }}</div>
                </div>
                <div class="route-arrow">→</div>
                <div class="route-station">
                  <div class="time">{{ booking.arriveTime }}</div>
                  <div class="code">{{ booking.arriveStation }}</div>
                </div>
              </div>
              <div class="booking-row"><span class="booking-key">Date</span><span class="booking-val">{{ booking.date }}</span></div>
              <div class="booking-row"><span class="booking-key">Bus type</span><span class="booking-val">{{ booking.busType }}</span></div>
              <!-- 取消預約按鈕，點擊開啟 cancel dialog -->
              <button class="cancel-full-btn" @click="openDialog('cancel', booking)">Cancel reservation</button>
            </div>
          </div>

          <!-- 無預約：顯示空狀態提示 -->
          <div v-else id="state-none">
            <div class="no-booking">
              <div class="no-booking-icon"><i class="fa fa-ticket"></i></div>
              <div class="no-booking-title">No active reservation</div>
              <div class="no-booking-text">Pick a bus from the timetable and click Reserve to book your seat.</div>
            </div>
          </div>

          <!-- 乘車注意事項 -->
          <div v-if="busNoticeData.length && noticeDismissed" class="notice-section">
            <ul class="notice-inline-list">
              <li v-for="(note, idx) in busNoticeData" :key="idx">{{ note }}</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- ═══════════════════════════════════════════════════════════
          右側欄位：時刻表
          - 手機版 (< 768px)：卡片列表，Reserve 按鈕全寬顯示，不需橫向捲動
          - 平板/桌面版 (>= 768px)：原本 table
          ═══════════════════════════════════════════════════════════ -->
      <div class="card timetable-card">
        <div class="card-body">
          <div class="tran-table-outlay table-responsive px-2">
            <template v-if="!resultData.length">
              <div class="empty-outlay">
                <!-- 載入中：顯示旋轉 icon -->
                <div v-if="isLoading" class="loading active">
                  <div class="icon"><i class="fa fa-circle-o-notch fa-spin"></i></div>
                </div>
                <!-- 無資料：顯示空狀態圖片 -->
                <div v-else class="empty-status">
                  <img src="/img/bus_no_result.svg" alt="No Result" />
                  <div class="title">No Result</div>
                </div>
              </div>
            </template>

            <template v-else>
              <!-- 手機/平板版：卡片列表 (完整顯示 6 站時間) -->
              <div class="bus-card-list d-lg-none">
                <div
                  v-for="(bus, busIdx) in resultData"
                  :key="busIdx"
                  class="bus-card"
                  :class="{ 'bus-card--booked': isMyBooking(bus) }"
                >
                  <div class="bus-card-stations">
                    <div
                      v-for="(time, timeIdx) in formatBusTime(bus.stationList)"
                      :key="timeIdx"
                      class="bus-card-station"
                    >
                      <div class="bus-card-station-code">{{ fields[timeIdx] }}</div>
                      <div class="bus-card-station-time">{{ time }}</div>
                    </div>
                  </div>
                  <div class="bus-card-meta">
                    <span class="bus-card-type">
                      {{ bus.busType }}
                      <span v-if="bus.vehicleType">({{ bus.vehicleType }})</span>
                    </span>
                    <span v-if="isMyBooking(bus)" class="badge badge-booked">My booking</span>
                    <span v-else-if="isBusFull(bus)" class="badge badge-full">Full</span>
                    <span v-else class="badge badge-normal">Available</span>
                  </div>
                  <button
                    class="btn-reserve btn-block"
                    :disabled="isMyBooking(bus) || isBusFull(bus)"
                    :class="{ 'btn-reserve--disabled': isMyBooking(bus) || isBusFull(bus) }"
                    @click="!isMyBooking(bus) && !isBusFull(bus) && handleReserveClick(bus)"
                  >
                    {{ isMyBooking(bus) ? 'Reserved' : 'Reserve' }}
                  </button>
                </div>
              </div>

              <!-- 桌面版：原本 table -->
              <table class="table table-hover d-none d-lg-table">
                <thead>
                  <tr class="head-fixed">
                    <th v-for="(field, idx) in fields" :key="idx">{{ field }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(bus, busIdx) in resultData"
                    :key="busIdx"
                    :class="{ 'booked-row': isMyBooking(bus) }"
                  >
                    <!-- 各站時間 -->
                    <td v-for="(time, timeIdx) in formatBusTime(bus.stationList)" :key="timeIdx">{{ time }}</td>
                    <td>
                      {{ bus.busType }}
                      <br />
                      <span v-if="bus.vehicleType">({{ bus.vehicleType }})</span>
                    </td>
                    <td>
                      <span v-if="isMyBooking(bus)" class="badge badge-booked">My booking</span>
                      <span v-else-if="isBusFull(bus)" class="badge badge-full">Full</span>
                      <span v-else class="badge badge-normal">Available</span>
                    </td>
                    <td>
                      <button
                        class="btn-reserve"
                        :disabled="isMyBooking(bus) || isBusFull(bus)"
                        :class="{ 'btn-reserve--disabled': isMyBooking(bus) || isBusFull(bus) }"
                        @click="!isMyBooking(bus) && !isBusFull(bus) && handleReserveClick(bus)"
                      >
                        {{ isMyBooking(bus) ? 'Reserved' : 'Reserve' }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
          </div>
        </div>
      </div>
    </template>

    <!-- ═══════════════════════════════════════════════════════════
         預約確認
         ═══════════════════════════════════════════════════════════ -->
    <div class="overlay" :class="{ active: activeDialog === 'reserve' }">
      <div class="dialog">
        <div class="dialog-header">
          <span class="dialog-title">Reserve shuttle</span>
          <button class="dialog-close" @click="closeAll()"><i class="fa fa-times"></i></button>
        </div>
        <div class="dialog-body" v-if="timetableDetail">
          <!-- 出發站 -->
          <div class="info-row"><span class="info-label">Departure</span><span class="info-val">{{ getBusEndpoints(timetableDetail).first.time }} {{ getBusEndpoints(timetableDetail).first.code }}</span></div>
          <!-- 抵達站 -->
          <div class="info-row"><span class="info-label">Arrival</span><span class="info-val">{{ getBusEndpoints(timetableDetail).last.time }} {{ getBusEndpoints(timetableDetail).last.code }}</span></div>
          <div class="info-row"><span class="info-label">Bus type</span><span class="info-val">{{ timetableDetail.busType }}</span></div>
        </div>
        <div class="dialog-footer">
          <button class="btn-ghost" @click="closeAll()">Discard</button>
          <!-- 送出中顯示轉圈，防止重複點擊 -->
          <button class="btn-primary" :disabled="isSubmitting" @click="confirmReserve()">
            <i v-if="isSubmitting" class="fa fa-circle-o-notch fa-spin"></i>
            {{ isSubmitting ? '' : 'Confirm' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ═══════════════════════════════════════════════════════════
         取消預約確認
         - 從左欄位 Cancel reservation 或時刻表 Cancel 按鈕開啟
         - 黑名單用戶也可取消黑名單前已建立的預約
         ═══════════════════════════════════════════════════════════ -->
    <div class="overlay" :class="{ active: activeDialog === 'cancel' }">
      <div class="dialog">
        <div class="dialog-header">
          <span class="dialog-title">Cancel booking</span>
          <button class="dialog-close" @click="closeAll()"><i class="fa fa-times"></i></button>
        </div>
        <div class="dialog-body" v-if="bookingRecord">
          <div class="info-row"><span class="info-label">Departure</span><span class="info-val">{{ bookingRecord.departTime }} {{ bookingRecord.departStation }}</span></div>
          <div class="info-row"><span class="info-label">Arrival</span><span class="info-val">{{ bookingRecord.arriveTime }} {{ bookingRecord.arriveStation }}</span></div>
          <div class="info-row"><span class="info-label">Bus type</span><span class="info-val">{{ bookingRecord.busType }}</span></div>
          <p style="font-size:13px; color:var(--color-text-secondary, #6c757d); margin-top:1rem;">Are you sure you want to cancel this reservation?</p>
        </div>
        <div class="dialog-footer">
          <button class="btn-ghost" @click="closeAll()">Keep it</button>
          <!-- 送出中顯示轉圈，防止重複點擊 -->
          <button class="btn-danger" :disabled="isSubmitting" @click="confirmCancel()">
            <i v-if="isSubmitting" class="fa fa-circle-o-notch fa-spin"></i>
            {{ isSubmitting ? '' : 'Confirm cancellation' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ═══════════════════════════════════════════════════════════
         預約成功
         ═══════════════════════════════════════════════════════════ -->
    <div class="overlay" :class="{ active: activeDialog === 'success' }">
      <div class="dialog">
        <div class="dialog-header">
          <span class="dialog-title">Done</span>
          <button class="dialog-close" @click="closeAll()"><i class="fa fa-times"></i></button>
        </div>
        <div class="dialog-body">
          <div class="result-icon"><i class="fa fa-check-circle"></i></div>
          <div class="result-title">Reservation successful</div>
          <div class="result-text">Your shuttle has been booked!</div>
        </div>
        <div class="dialog-footer">
          <button class="btn-primary" @click="closeAll()">Done</button>
        </div>
      </div>
    </div>

    <!-- ═══════════════════════════════════════════════════════════
         取消成功
         ═══════════════════════════════════════════════════════════ -->
    <div class="overlay" :class="{ active: activeDialog === 'cancelled' }">
      <div class="dialog">
        <div class="dialog-header">
          <span class="dialog-title">Done</span>
          <button class="dialog-close" @click="closeAll()"><i class="fa fa-times"></i></button>
        </div>
        <div class="dialog-body">
          <div class="result-icon"><i class="fa fa-trash"></i></div>
          <div class="result-title">Cancellation complete</div>
          <div class="result-text">Your reservation has been removed.</div>
        </div>
        <div class="dialog-footer">
          <button class="btn-primary" @click="closeAll()">Done</button>
        </div>
      </div>
    </div>

    <div class="overlay" :class="{ active: activeDialog === 'error' }">
      <div class="dialog">
        <div class="dialog-header">
          <span class="dialog-title">Unable to proceed</span>
          <button class="dialog-close" @click="closeErrorDialog()"><i class="fa fa-times"></i></button>
        </div>
        <div class="dialog-body">
          <div class="result-icon result-icon--error"><i class="fa fa-exclamation-circle"></i></div>
          <div class="result-text">{{ errorMessage }}</div>
        </div>
        <div class="dialog-footer">
          <button class="btn-primary" @click="closeErrorDialog()">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format, addHours, addDays } from 'date-fns';

export default {
  name: 'ReserveBus',
  data: () => ({
    isLoading: false, // 時刻表載入狀態
    isSubmitting: false, // 預約/取消送出中，防止重複點擊
    isPersonExist: true,

    // 搜尋表單
    form: {
      expectDepartureDate: '', // 使用者預期出發日期，預設今天
      expectDepartureTime: '', // 使用者預期出發時間，預設現在
      stationStart: '', // 出發站
      stationEnd: '', // 抵達站
    },

    // 時刻表欄位標題
    fields: ['FOC', 'T1', 'T2', 'FCCC', 'GBTP', 'FOC', 'Bus Type', 'Status', 'Action'],
    busStationData: [], // 站點 (篩選 FOC/T1/T2/FCCC/GBTP)
    busNoticeData: [], // 交通車公告
    resultData: [], // 時刻表
    bookingList: [], // 個人預約資料
    isBlacklisted: false, // 黑名單

    // 彈窗控制
    showNoticeModal: false, // 乘車注意事項彈窗
    noticeDismissed: false, // 注意事項彈窗已關閉，true 後才在左欄位顯示注意事項
    activeDialog: null, // 當前開啟的 dialog：'reserve' | 'cancel' | 'success' | 'cancelled'
    timetableDetail: null, // 點擊 Reserve 時暫存的班次物件，供 reserve dialog 顯示
    bookingRecord: null, // 點擊 Cancel 時暫存的預約物件，供 cancel dialog 顯示
    errorMessage: '',
  }),
  computed: {
    // impersonate
    impersonateMail() {
      return this.$store.getters.impersonateMail;
    },
    originalMailOrNot() {
      if (this.impersonateMail != "") {
        return this.impersonateMail === localStorage.getItem("mail");
      } else {
        return true;
      }
    },
    // 取得要傳給 API 的 impersonate 值
    impersonateId() {
      return this.impersonateMail ? this.impersonateMail.split('@')[0] : '';
    },
    // 最早可選時刻 = 當下時間 + 1 小時
    minAllowedDateTime() {
      return addHours(new Date(), 1);
    },
    // 最小可選日期
    minDate() {
      return format(this.minAllowedDateTime, 'yyyy-MM-dd');
    },
    // 最大可選日期 = 當下日期起 + 30天
    maxDate() {
      return format(addDays(new Date(), 30), 'yyyy-MM-dd');
    },
    // 最小可選時間：只有當選的日期剛好是 minDate 那天，才鎖時間下限
    // 若選的是未來日期，時間就不用限制（00:00 起）
    minTime() {
      return this.form.expectDepartureDate === this.minDate
        ? format(this.minAllowedDateTime, 'HH:mm')
        : '00:00';
    }
  },
  methods: {
    /**
     * 驗證並修正日期/時間，確保落在允許範圍內
     * (現在+1小時 ~ 今天起算+30天)
     * 在 input @change 及送出表單前都會呼叫
     */
    validateDateTime() {
      if (this.form.expectDepartureDate < this.minDate) {
        this.form.expectDepartureDate = this.minDate;
        this.form.expectDepartureTime = format(this.minAllowedDateTime, 'HH:mm');
        return;
      }
      if (this.form.expectDepartureDate > this.maxDate) {
        this.form.expectDepartureDate = this.maxDate;
        return;
      }
      if (
        this.form.expectDepartureDate === this.minDate &&
        this.form.expectDepartureTime < format(this.minAllowedDateTime, 'HH:mm')
      ) {
        this.form.expectDepartureTime = format(this.minAllowedDateTime, 'HH:mm');
      }
    },

    /**
     * 送出搜尋表單
     */
    async handleSubmit() {
      // 驗證時間
      this.validateDateTime();

      this.isLoading = true;
      try {
        const res = await this.getBusBookList(
          localStorage.getItem('access_token'),
          this.impersonateId,
          this.form.expectDepartureDate,
          this.form.expectDepartureTime,
          this.form.stationStart,
          this.form.stationEnd
        );
        this.resultData = (res.data.data && res.data.data.timetable) || [];
        this.isPersonExist = true;
        this.isBlacklisted = !!(res.data.data && res.data.data.isBlackList);
      } catch (err) {
        console.error(err);
        this.isPersonExist = false;
        this.resultData = [];
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * 取得預約注意事項
     */
    async busNotice() {
      try {
        const res = await this.getBusBookNotice(localStorage.getItem('access_token'));
        this.busNoticeData = (res.data.data && res.data.data.noteList) || [];
      } catch (err) {
        console.error(err);
      }
    },

    /**
     * 取得站點清單
     */
    async busStations() {
      try {
        const res = await this.getBusStation(localStorage.getItem('access_token'));
        this.busStationData = (res.data.data && res.data.data.stationList || []).filter((s) =>
          ['FOC', 'T1', 'T2', 'FCCC', 'GBTP'].includes(s.code)
        );
      } catch (err) {
        console.error(err);
      }
    },

    /**
     * 取得個人預約清單
     */
    async fetchMyBookings() {
      try {
        const res = await this.getCockpitReservation(
          localStorage.getItem('access_token'),
          this.impersonateId
        );
        const raw = (res.data.data && res.data.data.reservation) || [];
        this.bookingList = raw.map(this.formatBooking);
      } catch (err) {
        console.error(err);
      }
    },

    // ── 乘車注意事項彈窗 ──
    closeNoticeModal() {
      this.showNoticeModal = false;
      this.noticeDismissed = true;
    },

    /**
     * 把單一班次的站點資料，轉換成表格要顯示的時間清單
     * @param {Array} stationList - 這班車的站點清單，每個站包含 code 和 scheduledTime
     * @returns {Array} 6 個時間字串，順序對應表頭的 FOC/T1/T2/FCCC/GBTP/FOC
     */
    formatBusTime(stationList) {
      const list = stationList || [];
      return Array.from({ length: 6 }, (_, i) => (list[i] && list[i].scheduledTime) || '-');
    },

    /**
     * 取得班次的有效出發/抵達站點（過濾掉 scheduledTime 為 '-' 的站）
     * @param {Object} bus - 班次物件
     * @returns {{ first: {time, code}, last: {time, code} }}
     */
    getBusEndpoints(bus) {
      const empty = { time: '-', code: '-' };
      if (!bus || !bus.stationList || !bus.stationList.length) {
        return { first: empty, last: empty };
      }
      const withTime = bus.stationList.filter((s) => s.scheduledTime && s.scheduledTime !== '-');
      const first = withTime[0];
      const last = withTime[withTime.length - 1];
      return {
        first: { time: (first && first.scheduledTime) || '-', code: (first && first.code) || '-' },
        last: { time: (last && last.scheduledTime) || '-', code: (last && last.code) || '-' }
      };
    },

    /**
     * @param {Object} booking - API 回傳的單筆預約物件
     * @returns {Object} 含 departTime/departStation/arriveTime/arriveStation
     */
    formatBooking(booking) {
      const stations = booking.stationList || [];
      const first = stations[0] || {};
      const last = stations[stations.length - 1] || {};
      return {
        ...booking,
        departTime: first.scheduledTime || '-',
        departStation: first.code || '-',
        arriveTime: last.scheduledTime || '-',
        arriveStation: last.code || '-',
      };
    },

    /**
     * 判斷該班次是否為目前登入用戶的預約
     * status === 2 代表已被我預約
     * @param {Object} bus - 班次物件
     * @returns {boolean}
     */
    isMyBooking(bus) {
      return bus.status === 2;
    },

    /**
     * 判斷該班次是否已滿
     * status === 0 代表已滿
     * @param {Object} bus - 班次物件
     * @returns {boolean}
     */
    isBusFull(bus) {
      return bus.status === 0;
    },

    // ── 彈窗控制 ────────────────────────────────────────────

    /**
     * 開啟指定 dialog
     * @param {string} type - 'reserve' | 'cancel' | 'success' | 'cancelled'
     * @param {Object|null} payload - cancel 時傳入對應的預約物件
     */
    openDialog(type, payload = null) {
      this.activeDialog = type;
      if (type === 'cancel') {
        this.bookingRecord = payload;
      }
    },

    /**
     * 關閉所有 dialog，清空暫存的班次/預約物件
     */
    closeAll() {
      this.activeDialog = null;
      this.timetableDetail = null;
      this.bookingRecord = null;
    },

    /**
     * 專門關閉錯誤 dialog，順便清空錯誤訊息
     */
    closeErrorDialog() {
      this.activeDialog = null;
      this.errorMessage = '';
    },

    // ── 預約流程 ────────────────────────────────────────────

    /**
     * 點擊 Reserve 按鈕時觸發
     * @param {Object} bus - 選中的班次物件
     */
    handleReserveClick(bus) {
      this.timetableDetail = bus;
      this.openDialog('reserve');
    },

    /**
     * 確認預約
     */
    async confirmReserve() {
      if (!this.timetableDetail || this.isSubmitting) return;
      this.isSubmitting = true;
      try {
        await this.postCockpitReservation(
          localStorage.getItem('access_token'),
          this.impersonateId,
          this.timetableDetail.id
        );

        await this.handleSubmit();
        await this.fetchMyBookings();

        this.closeAll();
        this.openDialog('success');
      } catch (err) {
        console.error(err);

        this.errorMessage = (err && err.data && err.data.message && err.data.message.content)
          || 'Reservation failed. Please try again.';
        this.closeAll();
        this.openDialog('error');
      } finally {
        this.isSubmitting = false;
      }
    },

    /**
     * 確認取消預約
     */
    async confirmCancel() {
      if (!this.bookingRecord || this.isSubmitting) return;
      this.isSubmitting = true;
      try {
        await this.deleteCockpitReservation(
          localStorage.getItem('access_token'),
          this.impersonateId,
          this.bookingRecord.id
        );

        await this.handleSubmit();
        await this.fetchMyBookings();

        this.closeAll();
        this.openDialog('cancelled');
      } catch (err) {
        console.error(err);

        this.errorMessage = (err && err.data && err.data.message && err.data.message.content)
          || 'Cancellation failed. Please try again.';
        this.closeAll();
        this.openDialog('error');
      } finally {
        this.isSubmitting = false;
      }
    },
  },

  async created() {
    this.form.expectDepartureDate = format(this.minAllowedDateTime, 'yyyy-MM-dd');
    this.form.expectDepartureTime = format(this.minAllowedDateTime, 'HH:mm');
    this.isLoading = true;

    await Promise.all([
      this.busNotice(),
      this.busStations(),
      this.fetchMyBookings(),
    ]);

    await this.handleSubmit();
    this.isLoading = false;

    if (this.busNoticeData.length) {
      this.showNoticeModal = true;
    }
  },

  activated() {
    if (this.busNoticeData.length) this.showNoticeModal = true;
  },

  // impersonate 切換時重新載入時刻表和黑名單狀態
  watch: {
    impersonateMail() {
      this.handleSubmit();
      this.fetchMyBookings();
    }
  },
};
</script>

<style lang="scss" scoped>

.search-card {
  background: #ffffff;
  border: 0.5px solid #e9ecef;
  border-radius: 12px;
  padding: 1rem 1.25rem;
  margin-bottom: 16px;
  min-height: auto !important;
}

.empty-status {
  padding: 150px 0;
}

.tran-select-area {
  display: grid;
  align-items: end;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 12px;
  padding: 0;
  margin-bottom: 0;
}

.tran-input-group {
  label, select, input { font-size: 15px; }
  label { margin: 8px 0 5px 8px; color: #84754E; font-weight: bold; }
  .form-control { border-radius: 8px; }
}

.date-input input { width: 48%; border: none; }

.tran-table-btn {
  border-radius: 8px;
  font-size: 15px;
  width: 55%;
  min-width: fit-content;
  justify-self: end;
  white-space: nowrap;
}

/* 雙欄版面：左側 My Booking (400px 固定) + 右側時刻表 (彈性) */
.page-grid {
  display: grid;
  grid-template-areas:
    "impersonate impersonate"
    "search      search"
    "booking     timetable";
  grid-template-columns: 400px 1fr;
  gap: 16px;
  align-items: start;
}

.page-grid--empty {
  grid-template-areas:
    "impersonate impersonate"
    "empty       empty";
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;  
  min-height: calc(100vh - 250px);
}

.person-not-found {
  grid-area: empty;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.search-card    { grid-area: search; }
.status-panel   { grid-area: booking; position: sticky; top: 16px; }
.timetable-card { grid-area: timetable; }

.timetable-card {
  background: #ffffff;
  border: 0.5px solid #e9ecef;
  border-radius: 12px;
  overflow: hidden;
  min-height: calc(100vh - 365px);
}

.tran-table-outlay {
  max-height: calc(100vh - 380px);
  overflow-y: auto;
  position: relative;

  .table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
    margin: 0;

    thead th {
      background: #ffffff;
      padding: 9px 10px;
      text-align: center;
      font-weight: 500;
      font-size: 11px;
      color: #6c757d;
      border-bottom: 0.5px solid #e9ecef;
      white-space: nowrap;
      position: sticky;
      top: 0;
      z-index: 1;
    }

    tbody td {
      padding: 9px 10px;
      text-align: center;
      border-bottom: 0.5px solid #e9ecef;
      color: #212529;
      white-space: nowrap;
      vertical-align: middle;
    }

    tbody tr:hover { background-color: #f8f9fa !important; }
    tbody tr.booked-row { background-color: #FFF8EE !important; } /* 已預約班次高亮 */
  }
}

/* Status badge 樣式 */
.badge {
  display: inline-block;
  font-size: 13px;
  padding: 3px 10px;
  border-radius: 999px;
  font-weight: 500;
}
.badge-booked { background: #FAEEDA; color: #854F0B; } /* 已預約 */
.badge-normal { background: #EAF3DE; color: #3B6D11; } /* 可預約 */
.badge-full   { background: #f8d7da; color: #842029; } /* 已滿 */

/* Reserve 按鈕 */
.btn-reserve {
  font-size: 13px;
  padding: 3px 11px;
  border-radius: 6px;
  border: 0.5px solid #96694c;
  color: #96694c;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s;
  &:hover:not(:disabled) { background: #96694c; color: white; }
}

/* 黑名單或已滿時的 disable 樣式 */
.btn-reserve--disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* 左側 My Booking panel */
.status-panel {
  background: #ffffff;
  border: 0.5px solid #e9ecef;
  border-radius: 12px;
  overflow: hidden;
  position: sticky;
  top: 16px;
}
.status-panel-header {
  padding: 0.875rem 1.25rem;
  border-bottom: 0.5px solid #e9ecef;
  display: flex;
  align-items: center;
  gap: 8px;
}
.status-panel-title { font-size: 14px; font-weight: 500; }
.status-panel-body  { padding: 1.25rem; }

/* 黑名單提示條 */
.blacklist-banner {
  margin: 16px 16px 0;
  padding: 14px 18px;
  background-color: #fff1f2;
  border: 1px solid #fecdd3;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 14px;
  box-shadow: 0 2px 8px rgba(225, 29, 72, 0.08);
}

.blacklist-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #ffe4e6;
  color: #e11d48;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.blacklist-banner i {
  margin-top: 0;
}

.blacklist-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.blacklist-title {
  font-size: 15px;
  font-weight: 700;
  color: #881337;
  letter-spacing: 0.2px;
}

.blacklist-text {
  font-size: 13.5px;
  font-weight: 500;
  color: #be123c;
  line-height: 1.4;
}

/* 已預約卡片 */
.booking-card {
  background: #FFF8EE;
  border: 0.5px solid #FAC775;
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 1rem;
}
.booking-card-label {
  font-size: 13px;
  color: #a17a5f;
  font-weight: 500;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.booking-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
  border-bottom: 0.5px solid #FAEEDA;
  font-size: 13px;
  &:last-child { border-bottom: none; }
}
.booking-key { color: #a17a5f; }
.booking-val { font-weight: 500; color: #633806; }

/* 路線顯示：出發站 → 抵達站 */
.route-display {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0.75rem 0;
}
.route-station {
  .time { font-size: 18px; font-weight: 600; color: #633806; }
  .code { font-size: 12px; color: #a17a5f; margin-top: 2px; text-align: center; }
}
.route-arrow { color: #FAC775; font-size: 18px; }

/* 左欄位取消按鈕 (全寬) */
.cancel-full-btn {
  width: 100%;
  padding: 8px;
  font-size: 14px;
  background: #fbe9e9;
  color: #c94545;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  &:hover { opacity: 0.85; }
}

/* 無預約狀態 */
.no-booking { text-align: center; padding: 1.5rem 1rem; }
.no-booking-icon { font-size: 28px; margin-bottom: 10px; color: #6c757d; }
.no-booking-title { font-size: 14px; font-weight: 500; margin-bottom: 6px; }
.no-booking-text { font-size: 12px; color: #6c757d; line-height: 1.5; }

/* 左欄位英文注意事項區塊 (彈窗關閉後顯示) */
.notice-section {
  border-top: 0.5px solid #e9ecef;
  margin-top: 1rem;
  padding-top: 1rem;
}
.notice-inline-list {
  padding-left: 1.25rem;
  margin: 0;
  li {
    font-size: 12px;
    color: #6c757d;
    line-height: 1.8;
    list-style: disc;
  }
}

/* 手機/平板版：交通車班次卡片 (取代 table，Action 按鈕全寬顯示，不需橫向捲動) */
.bus-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.bus-card {
  border: 0.5px solid #e9ecef;
  border-radius: 10px;
  padding: 16px 18px;
  &--booked {
    background-color: #FFF8EE;
    border-color: #FAC775;
  }
}
/* 六站時間，格狀排列 */
.bus-card-stations {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 6px;
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 0.5px solid #f1f1f1;
}
.bus-card-station {
  text-align: center;
}
.bus-card-station-code {
  font-size: 12px;
  color: #a17a5f;
  font-weight: 600;
  margin-bottom: 4px;
}
.bus-card-station-time {
  font-size: 15px;
  color: #212529;
  font-weight: 600;
}
.bus-card-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #6c757d;
  margin-bottom: 14px;
}
.bus-card-type {
  white-space: nowrap;
}
.bus-card .badge {
  font-size: 14px;
}
.bus-card .btn-reserve {
  font-size: 15px;
  padding: 10px 11px;
}

/* 彈窗，active 時顯示 */
.overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1000;
  align-items: center;
  justify-content: center;
  &.active { display: flex; }
}

/* Dialog 本體 */
.dialog {
  background: #ffffff;
  border-radius: 12px;
  border: 0.5px solid #e9ecef;
  width: 340px;
  overflow: hidden;
  &--notice { width: 460px; }
}
.dialog-header {
  padding: 1rem 1.25rem;
  border-bottom: 0.5px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.dialog-title { font-size: 15px; font-weight: 500; }
.dialog-close { background: none; border: none; cursor: pointer; color: #6c757d; font-size: 18px; }
.dialog-body { padding: 1.25rem; }
.dialog-footer {
  padding: 1rem 1.25rem;
  border-top: 0.5px solid #e9ecef;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

/* 注意事項彈窗的列表樣式 */
.notice-modal-list {
  padding-left: 1.25rem;
  margin: 0;
  li { font-size: 14px; line-height: 2; list-style: disc; }
}

/* Dialog 內資訊列 */
.info-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  padding: 6px 0;
  border-bottom: 0.5px solid #e9ecef;
  &:last-child { border-bottom: none; }
}
.info-label { color: #6c757d; }
.info-val { font-weight: 500; }

/* 按鈕樣式 */
.btn-primary {
  padding: 10px 20px;
  font-size: 15px;
  font-weight: 500;
  background: $brand-primary;
  color: $color-white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  &:disabled { opacity: 0.6; cursor: not-allowed; }
}
.btn-ghost {
  padding: 7px 18px;
  font-size: 13px;
  background: none;
  border: 0.5px solid #ced4da;
  border-radius: 6px;
  cursor: pointer;
  color: #212529;
}
.btn-danger {
  padding: 7px 18px;
  font-size: 13px;
  font-weight: 500;
  background: #c94545;
  color: $color-white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  &:disabled { opacity: 0.6; cursor: not-allowed; }
}

/* 結果 dialog (成功/取消完成) */
.result-icon { text-align: center; padding: 1.5rem 0 1rem; font-size: 40px; }
.result-title { text-align: center; font-size: 15px; font-weight: 500; margin-bottom: 4px; }
.result-text { text-align: center; font-size: 13px; color: #6c757d; }
.result-icon--error {
  color: #dc3545;
}

/* 平板／手機，改為單欄，booking 移到搜尋上方
   確保橫向手機、平板寬度時時刻表欄位有足夠寬度顯示六站卡片 */
@media screen and (max-width: 1024px) {
  .timetable-card { min-height: calc(100vh - 665px); }
  .status-panel { position: static; }
  .page-grid {
    grid-template-areas: "impersonate" "booking" "search" "timetable";
    grid-template-columns: 1fr;
  }
  .page-grid--empty {
    grid-template-areas: "impersonate" "empty";
  }
  .tran-select-area { grid-template-columns: 1fr 1fr 1fr 1fr; }
  .tran-table-outlay { max-height: calc(100vh - 225px); }
}

@media screen and (max-width: 768px) {
  .tran-select-area { grid-template-columns: repeat(1, 1fr); grid-gap: 8px; padding: 0; }
  .tran-table-btn { margin-top: 1rem; width: 100%; }
  .dialog--notice {
    width: calc(100vw - 32px);
    max-height: 70vh;
  }
  .timetable-card {
    min-height: calc(100vh - 700px)
  }
  .empty-status {
    padding: 75px 0;
  }
}
</style>